const brand =
  window.location.host && window.location.host.includes('drtis.com.br')
    ? 'human'
    : 'vet';

export default brand;
